import type { DraftTrigger } from '../api/draft';

const TRIGGER_LABELS: Record<DraftTrigger, string> = {
  auto: 'auto',
  check: 'auto',
  regenerate_unresolved: 'regenerate unresolved',
  redraft_all: 'full redraft',
};

export function triggerLabel(trigger: DraftTrigger): string {
  return TRIGGER_LABELS[trigger];
}

export function relativeTime(now: Date, generatedAt: Date): string {
  const diffMs = now.getTime() - generatedAt.getTime();
  if (diffMs < 0) return 'just now';

  const diffSec = Math.floor(diffMs / 1000);
  if (diffSec < 60) return 'just now';

  const diffMin = Math.floor(diffSec / 60);
  if (diffMin < 60) return `${diffMin}m ago`;

  const diffHr = Math.floor(diffMin / 60);
  if (diffHr < 24) return `${diffHr}h ago`;

  const diffDays = Math.floor(diffHr / 24);
  return `${diffDays}d ago`;
}

export function freshnessText(
  generatedAt: string | undefined,
  trigger: DraftTrigger | undefined,
  now: Date = new Date(),
): string {
  if (!generatedAt) return '';

  const ts = new Date(generatedAt);
  if (isNaN(ts.getTime())) return '';

  const rel = relativeTime(now, ts);
  const label = trigger ? triggerLabel(trigger) : '';
  return label ? `drafted ${rel} · ${label}` : `drafted ${rel}`;
}
